import { render } from "./promoBlock.vue?vue&type=template&id=51e0970a&scoped=true&ts=true"
import script from "./promoBlock.vue?vue&type=script&lang=ts"
export * from "./promoBlock.vue?vue&type=script&lang=ts"

import "./promoBlock.vue?vue&type=style&index=0&id=51e0970a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e0970a"]])

export default __exports__